import { render, staticRenderFns } from "./NewMessengerConversation.vue?vue&type=template&id=bed11bf0&scoped=true"
import script from "./NewMessengerConversation.vue?vue&type=script&lang=js"
export * from "./NewMessengerConversation.vue?vue&type=script&lang=js"
import style0 from "./NewMessengerConversation.vue?vue&type=style&index=0&id=bed11bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed11bf0",
  null
  
)

export default component.exports